import styles from './breadcrumbStyle.module.scss'
import { Breadcrumbs } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
const BreadcrumbCustom = ({
	onClick,
	className = '', // Default className as an empty string
	children,
	...rest
}) => {
	return (
		<>
			<Breadcrumbs
				separator={<NavigateNextIcon fontSize="small" />}
				aria-label="breadcrumb"
				sx={{ flexGrow: 1 }}
				className={`${styles.breadcrumbs} ${className}` || className}
				onClick={onClick}
				{...rest}
			>
				{children}
			</Breadcrumbs>
		</>
	)
}

export default BreadcrumbCustom
